import styled from "styled-components";
import {
  Button,
  ButtonProps,
  colors,
  LinkNext,
  media,
} from "@literati/public-ui-shared-react";
import { CircleTestimonial } from "components/checkout/CircleTestimonial";
import { makeQueryString } from "@literati/kids-api";
import { LINKS } from "globalConfig";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
import analytics from "analytics";
import { ReactNode } from "react";

const TESTIMONIAL_CONTENT = [
  {
    header: "81% of readers",
    content:
      "find their favorite book with Literati when parents complete their profile",
    imageProps: {
      src: "https://images.ctfassets.net/vqtz4cq2w5ts/4FiYN1KnRiQgISYcjt2ghs/7544e09630f8ea80bc8fe661249e7a79/Testimonial_Graphic_1.png",
    },
  },
  {
    header: "75% of parents",
    content:
      "say personalizing with Literati has increased their child’s interest in reading",
    imageProps: {
      src: "https://images.ctfassets.net/vqtz4cq2w5ts/29Ua1LDltHx8cjcYHXHatL/006e0699bbbe209aa58330bc60c69201/Testimonial_Graphic_2.png",
    },
  },
];

const HeaderText = styled.h2`
  font-family: hoefler;
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
  max-width: 450px;
  color: ${colors.inkBlack};
  margin: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TestimonialList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2rem auto;
  gap: 1rem;
  ${media.lg} {
    flex-direction: row;
  }
`;

const CTA_LABEL = "Complete Your Reader Profile";

type SharedProps = {
  ctaLabel?: ReactNode;
  subscriptionId: number;
  suppressButton?: boolean;
};

export type TestimonialCTAProps =
  | (SharedProps & {
      variant: "link";
      href?: string;
    })
  | (SharedProps & {
      variant: "button";
      buttonProps: ButtonProps;
    });

export const TestimonialCTA = (props: TestimonialCTAProps) => {
  const { ctaLabel, subscriptionId, suppressButton = false, variant } = props;

  const isMobile = !useMediaQuery(media.lg);
  const getImageOrientationByIndex = (i: number) => {
    // Desktop should always display on the left
    if (!isMobile) {
      return "left";
    }
    // Alternate between left and right mobile
    return i % 2 == 0 ? "left" : "right";
  };

  return (
    <Container>
      <HeaderText>An Experience as Unique as Your Reader</HeaderText>
      <TestimonialList>
        {TESTIMONIAL_CONTENT.map((props, i) => (
          <CircleTestimonial
            key={`circle-testimonial-${i}`}
            {...props}
            imageOrientation={getImageOrientationByIndex(i)}
          />
        ))}
      </TestimonialList>
      {!suppressButton && variant === "link" ? (
        <LinkNext
          buttonVariantStyle="primary"
          css="margin: 1rem auto"
          href={
            props.href || LINKS.shuffle + makeQueryString({ subscriptionId })
          }
          legacyBehavior={false}
          variant="button"
          onClick={() => analytics.trackAmplitudeClickEvent(CTA_LABEL)}
        >
          {ctaLabel || CTA_LABEL}
        </LinkNext>
      ) : null}
      {!suppressButton && variant === "button" ? (
        <Button css="margin: 1rem auto" {...props.buttonProps} />
      ) : null}
    </Container>
  );
};
